import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AckReject } from 'src/app/models/ack-reject';
import { BackendListModel } from 'src/app/models/common/list.model';
import { DeclineReason } from 'src/app/models/decline-reason';
import { AckRequestService } from 'src/app/services/ack-request.service';
import { MyOrdersService } from '../my-orders-table/my-orders-table.service';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { RequestServeComponent } from '../request-serve/request-serve.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'logzy-request-reject-form',
  templateUrl: './request-reject-form.component.html',
  styleUrls: ['../request-form.scss']
})
export class RequestRejectFormComponent implements OnInit {
  errorObj: any = {};
  modelService: MyOrdersService;
  ackService: AckRequestService;
  reason_List: BackendListModel<DeclineReason>;
  @Input() show: boolean = true;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() updateAction: EventEmitter<any> = new EventEmitter();
  @Input() changeToStatus = null;
  @Input() changeToStatusDevName = null;
    constructor(private ackRequest: AckRequestService, private myOrderService: MyOrdersService, private snackBar: MatSnackBar,
      public requestService: RequestApiService,private route: ActivatedRoute, private router: Router
    ) { }

  @Input()
  rejectObject: AckReject;

  defaultreject: AckReject = {
    id: null,
    remarks: "OK",
    decline_reason: null
  }
  @ViewChild(RequestServeComponent) RequestServeComponent!: RequestServeComponent;
  request_id = '';
  type = '';
  rtype = '';
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if ('id' in params) {
          this.request_id = params['id'];
      }
      if ('type' in params) {
        this.type = params['type'];
    }
    if ('rtype' in params) {
      this.rtype = params['rtype'];
  }
  })
    console.log("changeToStatus",this.changeToStatus);
    console.log("changeToStatusDevName",this.changeToStatusDevName);
    this.getDeclineReasons();
    this.rejectObject = { ...this.defaultreject };
    this.modelService = this.myOrderService;
    this.ackService = this.ackRequest;
  }
  rejectRequest() {
    this.ackRequest.rejectRequest(this.rejectObject, this.ackService.selectedRequest.id).subscribe({
      next: response => {
        this.snackBar.open("Request Reject Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        // this.modelService.getRequestDetails();
        this.close.emit();
        this.updateAction.emit();
      },
      error: error => {
        return this.catchError(error);
      }
    })
  }
  //For Decline Reason List
  getDeclineReasons() {
    this.ackRequest.getDeclineReasons().subscribe(response => {
      this.reason_List = response;
    })
  }
  resetExpand(){
    this.requestService.bookingDetailsExpand= true;
    console.log("RequestServeComponent",RequestServeComponent)
    // this.RequestServeComponent?.ngOnInit();
    window.location.reload();
    // this.refreshSameUrl();
  }

  // Function to catch errors
  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    }
  }
  refreshSameUrl(){
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(`/requests/request-processing/request-details?id=${this.request_id}&type=${this.type}&rtype=${this.rtype}`);
    });
  }
}
